import React, { useState, useEffect } from 'react'

import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material'
import { IImageModuleProps } from '../../../Post/modules/Image'

const InstaProfileImage: React.FC<IImageModuleProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    img: {
      borderRadius: '50%',
      height: '28px',
      width: '28px',
      margin: '5px 10px',
    },
  }))
  const classes = useStyles()

  const [imageSrc, setImageSrc] = useState<string>('/src/shared/assets/images/defaultFacebookProfileImage.jpg')

  // Only test and load the image when props.data changes
  useEffect(() => {
    if (props.data) {
      const img = new Image()
      
      img.onload = () => {
        setImageSrc(props.data!)
      }
      
      img.onerror = () => {
        setImageSrc('/src/shared/assets/images/defaultFacebookProfileImage.jpg')
      }

      img.src = props.data
    } else {
      setImageSrc('/src/shared/assets/images/defaultFacebookProfileImage.jpg')
    }
  }, [props.data])

  return (
    <>
      <img className={classes.img} src={imageSrc} />
    </>
  )
}

export default React.memo(InstaProfileImage)
